import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const opi = '/api/organization/'
const cpi = '/api/currency/'
const ipi = '/api/student-invoice/'
const ori = '/api/org-invoice/'
const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const ListOrganization = createAsyncThunk('organizations', (params: {}, thunkAPI) =>
  handleRequest(get(`${opi}list`, params), thunkAPI)
)

export const createOrganization = createAsyncThunk('add-organization', (data: {}, thunkAPI) =>
  handleRequest(post(`${opi}store`, data), thunkAPI)
)

export const editOrganization = createAsyncThunk('organization-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${opi}edit/${id}`), thunkAPI)
)

export const deleteOrganization = createAsyncThunk('organization-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`${opi}destroy/${id}`), thunkAPI)
)

export const viewOrganization = createAsyncThunk('organization-view', (id: string, thunkAPI) =>
  handleRequest(get(`${opi}view/${id}`), thunkAPI)
)

// currency
export const ListCurrency = createAsyncThunk('currencies', (params: {}, thunkAPI) =>
  handleRequest(get(`${cpi}list`, params), thunkAPI)
)

export const createCurrency = createAsyncThunk('add-currency', (data: {}, thunkAPI) =>
  handleRequest(post(`${cpi}store`, data), thunkAPI)
)

export const editCurrency = createAsyncThunk('currency-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${cpi}edit/${id}`), thunkAPI)
)

export const deleteCurrency = createAsyncThunk('currency-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`${cpi}destroy/${id}`), thunkAPI)
)

export const ListStudent = createAsyncThunk('students', (_, thunkAPI) =>
  handleRequest(get(`${ipi}get-students`), thunkAPI)
)

export const GetStudentDetails = createAsyncThunk(
  'std-detsils',
  ({id, type}: {id: string; type: string}, thunkAPI) =>
    handleRequest(get(`${ipi}get-student-details/${id}/${type}`), thunkAPI)
)

export const GetStdProgram = createAsyncThunk('std-pro', (id: string, thunkAPI) =>
  handleRequest(get(`${ipi}get-std-program/${id}`), thunkAPI)
)

export const createStudentInvoice = createAsyncThunk('add-invoice', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}store`, data), thunkAPI)
)

export const ListStudentInvoice = createAsyncThunk('invoices', (params: {}, thunkAPI) =>
  handleRequest(get(`${ipi}list`, params), thunkAPI)
)

export const deleteStudentInvoice = createAsyncThunk('invoice-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`${ipi}destroy/${id}`), thunkAPI)
)

export const studentInvoiceDetails = createAsyncThunk('invoice-view', (id: string, thunkAPI) =>
  handleRequest(get(`${ipi}view/${id}`), thunkAPI)
)

export const editStudentInvoiceInvoice = createAsyncThunk('invoice-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${ipi}edit/${id}`), thunkAPI)
)

export const GetPayments = createAsyncThunk('payments', (id: string, thunkAPI) =>
  handleRequest(get(`${ipi}get-payments/${id}`), thunkAPI)
)

export const CreateStudentInvoicePayment = createAsyncThunk(
  'add-student-invoice-payment',
  (data: {}, thunkAPI) => handleRequest(post(`${ipi}store-payment`, data), thunkAPI)
)

export const PrintStudentInvoice = createAsyncThunk('print-invoice', (id: string, thunkAPI) =>
  handleRequest(get(`${ipi}print/${id}`), thunkAPI)
)

export const emailStudentInvoice = createAsyncThunk('email-invoice', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}email-invoice`, data), thunkAPI)
)

export const InvoiceSummary = createAsyncThunk('invoice-summary', (id: any, thunkAPI) =>
  handleRequest(get(`${ipi}invoice-summary/${id}`), thunkAPI)
)

export const changeInstallmentDate = createAsyncThunk('change-inst-date', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}change-installment-date`, data), thunkAPI)
)

export const PaymentDelete = createAsyncThunk('delete-payment', (id: any, thunkAPI) =>
  handleRequest(get(`${ipi}delete-payment/${id}`), thunkAPI)
)

export const StdInvoices = createAsyncThunk('std-invoice', (id: any, thunkAPI) =>
  handleRequest(get(`${ipi}std-invoices/${id}`), thunkAPI)
)

export const GetInvDetails = createAsyncThunk('get-inv-details', (id: string, thunkAPI) =>
  handleRequest(get(`${ipi}get-inv-details/${id}`), thunkAPI)
)

export const PaymentGraph = createAsyncThunk('payment-graph', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}payment-dashboard`, data), thunkAPI)
)

export const InvSumDetails = createAsyncThunk(
  'payment-graph',
  ({type, academicYear}: {type: string; academicYear: string}, thunkAPI) =>
    handleRequest(get(`${ipi}payment-dashboard/${type}/${academicYear}`), thunkAPI)
)

export const InvSumDetailsPrint = createAsyncThunk(
  'summary-print',
  ({type, academicYear}: {type: string; academicYear: string}, thunkAPI) =>
    handleRequest(get(`${ipi}summary-print/${type}/${academicYear}`), thunkAPI)
)

export const SummaryExcel = createAsyncThunk(
  'summary-excel',
  async ({type, academicYear}: {type: string; academicYear: string}) => {
    const response = await axios.get(`${ipi}summary-excel/${type}/${academicYear}`, {
      responseType: 'blob',
    })
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'StudentPayments.xlsx'
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const MonthlyReport = createAsyncThunk('std-inv-monthly-report', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}monthly-reports`, data), thunkAPI)
)

export const MonthlyReportPrint = createAsyncThunk('monthly-report-print', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}monthly-report-print`, data), thunkAPI)
)

export const MonthlyReportExcel = createAsyncThunk(
  'monthly-report-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/student-invoice/monthly-report-excel', formData, {
      responseType: 'blob',
    })
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'StudentPayments.xlsx'
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const SendCustomReminder = createAsyncThunk('send-custom-reminder', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}send-custom-reminder`, data), thunkAPI)
)

export const SendCustomReminders = createAsyncThunk('send-custom-reminders', (data: {}, thunkAPI) =>
  handleRequest(post(`${ipi}send-custom-reminders`, data), thunkAPI)
)

export const DestroyNotification = createAsyncThunk('destroy-notification', (id: any, thunkAPI) =>
  handleRequest(post(`${ipi}destroy-notification/${id}`), thunkAPI)
)

export const PrintInvoiceList = createAsyncThunk('list-print', (id: any, thunkAPI) =>
  handleRequest(post(`${ipi}list-print/${id}`), thunkAPI)
)

export const InvoiceListExcel = createAsyncThunk('list-excel', async (params: {}) => {
  const response = await axios.get('/api/student-invoice/list-excel', {
    params,
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'Student Invoices List.xlsx'
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
})

export const Say = createAsyncThunk('std-ay', (_, thunkAPI) =>
  handleRequest(get(`${ipi}ay`), thunkAPI)
)

export const FinanceOpts = createAsyncThunk('fin-opts', (params: {}, thunkAPI) =>
  handleRequest(
    get(`${ipi}params`, {
      params: params,
    }),
    thunkAPI
  )
)

export const createMulInv = createAsyncThunk('cmi', (data: {}, thunkAPI) =>
  handleRequest(post('/api/student-invoice/store-multi-inv', data), thunkAPI)
)

export const InvoiceUpdate = createAsyncThunk('invoice-update', (data: {}, thunkAPI) =>
  handleRequest(post(`${ori}update-invoice`, data), thunkAPI)
)

export const OrgInvoiceList = createAsyncThunk('org-invoices', (params: {}, thunkAPI) =>
  handleRequest(get(`${ori}list`, params), thunkAPI)
)

export const OrgInvoiceCreate = createAsyncThunk('add-org-inv', (data: {}, thunkAPI) =>
  handleRequest(post(`${ori}store`, data), thunkAPI)
)

export const OrgInvoices = createAsyncThunk('org-invoice', (id: any, thunkAPI) =>
  handleRequest(get(`${ori}org-invoices/${id}`), thunkAPI)
)

export const OrgInvoiceInvoiceEdit = createAsyncThunk('org-invoice-edit', (id: any, thunkAPI) =>
  handleRequest(get(`${ori}edit/${id}`), thunkAPI)
)

export const OrgInvoiceDelete = createAsyncThunk('org-invoice-destroy', (id: any, thunkAPI) =>
  handleRequest(get(`${ori}destroy/${id}`), thunkAPI)
)

export const OrgInvoiceDetails = createAsyncThunk('org-invoice-view', (id: any, thunkAPI) =>
  handleRequest(get(`${ori}view/${id}`), thunkAPI)
)

export const OrgChangeInstallmentDate = createAsyncThunk('change-inst-date', (data: {}, thunkAPI) =>
  handleRequest(post(`${ori}change-installment-date`, data), thunkAPI)
)

export const GetOrgPayments = createAsyncThunk('org-payments', (id: any, thunkAPI) =>
  handleRequest(get(`${ori}get-payments/${id}`), thunkAPI)
)

export const OrgInvoicePaymentCreate = createAsyncThunk(
  'add-org-invoice-payment',
  (data: {}, thunkAPI) => handleRequest(post(`${ori}store-payment`, data), thunkAPI)
)

export const OrgInvoicePrint = createAsyncThunk('print-org-invoice', (id: any, thunkAPI) =>
  handleRequest(get(`${ori}print/${id}`), thunkAPI)
)

export const OrgPaymentDelete = createAsyncThunk('delete-payment', (id: any, thunkAPI) =>
  handleRequest(get(`${ori}delete-payment/${id}`), thunkAPI)
)

export const EmailOrgInvoice = createAsyncThunk('org-email-invoice', (id: string, thunkAPI) =>
  handleRequest(get(`${ori}email/${id}`), thunkAPI)
)

export const OrgInvoiceSummary = createAsyncThunk('org-invoice-summary', (_, thunkAPI) =>
  handleRequest(get(`${ori}invoice-summary`), thunkAPI)
)

export const GetInvOrgDetails = createAsyncThunk('get-inv-details', (id: string, thunkAPI) =>
  handleRequest(get(`${ori}get-inv-details/${id}`), thunkAPI)
)

export const InvoiceOrgUpdate = createAsyncThunk('invoice-update', (data: {}, thunkAPI) =>
  handleRequest(post(`${ori}update-invoice`, data), thunkAPI)
)

type FinanceState = {
  record: any
  records: any
  errors: any
}

const initialState: FinanceState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const financeSlice = createSlice({
  name: 'finance',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListOrganization.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListCurrency.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCurrency.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(createStudentInvoice.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListStudentInvoice.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = financeSlice.actions
export default financeSlice.reducer
